<template>
    <app-layout title="Settings">
        <page-header>
            <template #title>Settings</template>

            <template #actions>

            </template>

        </page-header>

        <settings-navigation />

        <div class="px-8">
            <div class="flex">

            </div>
        </div>

    </app-layout>
</template>

<script>
// import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetButton from '@/Jetstream/Button';
import JetInput from '@/Jetstream/Input';
import JetLabel from '@/Jetstream/Label';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import SettingsNavigation from '@/Pages/Settings/Partials/SettingsNavigation';


export default {

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetInput,
        JetLabel,
        JetSecondaryButton,
        JetTertiaryButton,
        SettingsNavigation,
    },

    props: [],

    data() {
        return {

        }
    },

    methods: {


    },

    computed: {

    },

    watch: {

    },

    mounted() {
    }
}
</script>

<style scoped>


</style>